import { useColorMode, usePreferredDark, useStyleTag } from '@vueuse/core'
import { computed } from 'vue'

const theme = useColorMode({
  selector: 'body',
  modes: {
    auto: '',
    light: 'theme-light',
    dark: 'theme-dark'
  },
  emitAuto: true
})

useStyleTag(`
  body.theme-light { color-scheme: light; }
  body.theme-dark { color-scheme: dark; }
`, { id: 'vueuse-color-scheme-bridge' })

const preferredDark = usePreferredDark({ window })
const selectedTheme = computed(() => theme.value === 'auto'
  ? preferredDark.value ? 'dark' : 'light'
  : theme.value
)

export default () => ({
  theme,
  selectedTheme
})
